import { State } from '@meraki-internal/state';
import { IHeaderTabGroup } from './HeaderTabs';

export interface IAppHeaderOverrideProps {
    title?: string | React.ReactNode;
    hidden?: boolean;
    tabs?: IHeaderTabGroup;
    fullWidth?: boolean;
    hidesBeaButton?: boolean;
}

export class AppHeaderOverrideState extends State<Record<string, never>> {
    constructor() {
        super({});
    }

    // Counts sets rather than timing them: a page re-setting its header clears and sets within
    // the same millisecond.
    private sets = 0;

    set = ({ title, hidden, tabs, fullWidth, hidesBeaButton }: IAppHeaderOverrideProps) => {
        this.title = title;
        this.hidden = hidden;
        this.tabs = tabs;
        this.fullWidth = fullWidth;
        this.hidesBeaButton = hidesBeaButton;

        this.sets++;

        this.setState({ });
    };

    clear = () => {
        const sets = this.sets;

        // to avoid header flicker, when we unload wait a moment,
        // and only clear state if set() has not been called again
        setTimeout(() => {
            if (this.sets === sets) {
                this.title = undefined;
                this.hidden = undefined;
                this.tabs = undefined;
                this.fullWidth = undefined;
                this.hidesBeaButton = undefined;
                this.setState({ });
            }
        }, 500);
    };

    title?: string | React.ReactNode;
    hidden?: boolean;
    tabs?: IHeaderTabGroup;
    fullWidth?: boolean;
    hidesBeaButton?: boolean;
}
